(() => {
  // Zustand des Warenkorb-Buttons (Select Size / Add to cart / Notify) je Button-Wrapper.
  // Es gibt mehrere Wrapper: Produktseite, Quick-Add-Panel im Warenkorb-Drawer, Styled-With.
  // Jeder Wrapper bekommt eigene Beobachter, neue Wrapper (Quick-Add) werden ueber einen Body-Observer erkannt.
  const WRAPPER = '.wt-product__add-to-cart_form--wrapper.product-form__buttons';
  const seen = new WeakSet();

  function initWrapper(wrapper) {
    if (!wrapper || seen.has(wrapper)) return;
    seen.add(wrapper);

    const atcBtn = wrapper.querySelector('.js-add-to-cart.product-form__submit');
    const span = atcBtn ? atcBtn.querySelector('span') : null;
    let lastKnownGoodText = 'ADD TO CART';
    let spanObserver = null;
    let isUpdatingText = false;
    let variantEverSelected = false;

    function setSpanText(text) {
      if (!span) return;
      if (spanObserver) spanObserver.disconnect();
      isUpdatingText = true;
      span.textContent = text;
      isUpdatingText = false;
      if (spanObserver) spanObserver.observe(span, { childList: true, characterData: true, subtree: true });
    }

    function applyState(fromMutation) {
      const notifyContainer = wrapper.querySelector('.restock-rocket-button-container');
      const isDisabled = atcBtn ? atcBtn.hasAttribute('disabled') : false;

      // Wenn MutationObserver feuert = Shopify hat etwas geaendert = Variante wurde gewaehlt
      if (fromMutation) variantEverSelected = true;

      const soldOut = isDisabled && !!notifyContainer;
      const noVariant = isDisabled && !notifyContainer && !variantEverSelected;
      // Ausverkauft ohne Benachrichtigungs-Button (z. B. im Quick-Add, dort laeuft die App nicht): Theme-Text 'Sold out' bleibt
      const soldOutPlain = isDisabled && !notifyContainer && variantEverSelected;
      const classes = wrapper.classList;

      if (soldOut) {
        classes.remove('rr-show-notify', 'rr-no-variant', 'rr-available', 'rr-sold-out');
        classes.add('rr-show-notify');
      } else if (soldOutPlain) {
        classes.remove('rr-show-notify', 'rr-no-variant', 'rr-available', 'rr-sold-out');
        classes.add('rr-sold-out');
      } else if (noVariant) {
        classes.remove('rr-show-notify', 'rr-no-variant', 'rr-available', 'rr-sold-out');
        classes.add('rr-no-variant');
        setSpanText('Select Size');
      } else {
        classes.remove('rr-show-notify', 'rr-no-variant', 'rr-available', 'rr-sold-out');
        classes.add('rr-available');
        if (span) {
          const currentText = span.textContent.trim().toLowerCase();
          const isBadText = currentText.includes('sold out') ||
                            currentText.includes('ausverkauft') ||
                            currentText.includes('select size');
          if (isBadText) setSpanText(lastKnownGoodText);
        }
      }
    }

    function rafBurst(fromMutation) {
      applyState(fromMutation);
      requestAnimationFrame(() => {
        applyState(fromMutation);
        requestAnimationFrame(() => applyState(fromMutation));
      });
    }

    rafBurst(false);

    // Observer erst nach 500ms starten, gibt Shopify Zeit zu initialisieren, ohne variantEverSelected zu setzen.
    // Aenderungen im Dynamic-Checkout-Wrapper (Hydration des Zahlungsbuttons) werden ignoriert.
    setTimeout(() => {
      const obs = new MutationObserver((records) => {
        const relevant = records.some((r) => !(r.target.closest && r.target.closest('.wt-product__dynamic-checkout')) && !(r.target.parentElement && r.target.parentElement.closest('.wt-product__dynamic-checkout')));
        if (relevant) rafBurst(true);
      });
      obs.observe(wrapper, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled'] });
    }, 500);

    if (span) {
      spanObserver = new MutationObserver(() => {
        if (!isUpdatingText) {
          applyState(true);
          requestAnimationFrame(() => applyState(true));
        }
      });
      spanObserver.observe(span, { childList: true, characterData: true, subtree: true });
    }
  }

  function boot() {
    document.querySelectorAll(WRAPPER).forEach(initWrapper);
    // Quick-Add-Panel: der Produktinhalt wird spaeter eingefuegt
    new MutationObserver((records) => {
      for (const r of records) {
        for (const node of r.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(WRAPPER)) initWrapper(node);
          if (node.querySelectorAll) node.querySelectorAll(WRAPPER).forEach(initWrapper);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();